export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
export const DELETE = 'DELETE';

export const CONTENT_TYPE = 'Content-Type';
export const APPLICATION_JSON = 'application/json';
